import type {
  ServiceBinding,
  ServiceContainer,
  ServiceToken,
} from "../contracts";

export interface MutableServiceContainer extends ServiceContainer {
  bind(binding: ServiceBinding): void;
  bindAll(bindings: readonly ServiceBinding[]): void;
}

export function createServiceContainer(): MutableServiceContainer {
  const values = new Map<string, unknown>();

  function tryResolve<T>(token: ServiceToken<T>): T | undefined {
    return values.get(token.key) as T | undefined;
  }

  return {
    bind(binding) {
      values.set(binding.token.key, binding.value);
    },

    bindAll(bindings) {
      for (const binding of bindings) {
        values.set(binding.token.key, binding.value);
      }
    },

    tryResolve,

    resolve<T>(token: ServiceToken<T>): T {
      if (!values.has(token.key)) {
        throw new Error(
          `Service "${token.key}" was requested before any module provided it.`,
        );
      }

      return values.get(token.key) as T;
    },

    has(token) {
      return values.has(token.key);
    },
  };
}
